import {connect} from 'react-redux';

import AppRouterContainer from './AppRouterContainer';
import {logInAction} from '../../Login/Redux/LoginActions';
import {UserState} from '../../types';

export interface State {
    user: UserState;
}

export const mapState = (state: State) => {
    return {
        user: state.user,
    };
};

export const mapDispatch = {
    login: logInAction,
};

export default connect(mapState, mapDispatch)(AppRouterContainer);
